export enum RequestStatus {
  Init = 'init',
  Loading = 'loading',
  Done = 'done',
  Error = 'error',
}
